import axiosHttp from "../../config/axios.interceptor";
import { errorResponseMessage } from "../../shared/const.prop";
import { calendarReducerConstant } from "../reducerConstant";

export const getTimeZoneList = () => async (dispatch) => {
  try {
    const timeZoneList = await axiosHttp.get(`timezone`);
    dispatch({
      type: calendarReducerConstant.SET_TIMEZONE_LIST,
      payload: timeZoneList?.data?.data || [],
    });
  } catch (err) {
    //console.log(`Err while fetching timezone info ${err}`);
  }
};

export const getCalendarScheduleInfo = () => async (dispatch) => {
  try {
    const calendarInfo = await axiosHttp.get(`calendars`);
    const dataFromAPI = calendarInfo?.data?.data || {};
    const formattedData = {
      timezoneId: dataFromAPI?.timezoneId || "",
      bookingPeriod: dataFromAPI?.bookingPeriod || "",
      noticePeriodNum: dataFromAPI?.noticePeriodNum || "",
      noticePeriod: "Days",
      scheduleDays: dataFromAPI?.scheduleDays || [],
      unavailableDays: dataFromAPI?.unavailableDays || [],
    };
    dispatch({
      type: calendarReducerConstant.SET_CALENDARSCHEDULE_INFO,
      payload: formattedData || {},
    });
  } catch (err) {
    if (err.response.status === 429) {
      appContext.updateNotificationState({
        show: true,
        message: errorResponseMessage(err),
        type: "error",
      });
      authContext.logout();
    }
    if (err.response?.status >= 500) {
      appContext.updateNotificationState({
        show: true,
        message: "Something went wrong, please try again later.",
        type: "error",
      });
    }
    //console.log(`Err while fetching timezone info ${err}`);
  }
};

export const updateCalendarSettings = async ({
  updatedData = {},
  successCallback,
  failureCallback,
}) => {
  try {
    const updateResponse = await axiosHttp.post("calendars", {
      timezone: updatedData?.timezoneId,
      bookingPeriod: updatedData?.bookingPeriod,
      noticePeriodNum: updatedData?.noticePeriodNum,
      noticePeriod: "Days",
    });
    if (updateResponse && updateResponse?.status === 201 && successCallback) {
      successCallback();
    }
  } catch (err) {
    if (failureCallback) {
      failureCallback(err);
    }
  }
};

export const updateCalendarSchedule = async ({
  updatedData = {},
  successCallback,
  failureCallback,
}) => {
  try {
    const updateResponse = await axiosHttp.post("schedule", {
      ...updatedData,
    });
    if (updateResponse && updateResponse?.status === 201 && successCallback) {
      successCallback();
    }
  } catch (err) {
    if (failureCallback) {
      failureCallback(err);
    }
  }
};

export const removeBlockedDates = (index, successCallback, failureCallback) => {
  return async (dispatch, getState) => {
    const { calendar } = getState();
    if (
      calendar?.calendarScheduleInfo &&
      Object.keys(calendar?.calendarScheduleInfo).length > 0 &&
      calendar?.calendarScheduleInfo?.unavailableDays
    ) {
      const blockedDates = calendar?.calendarScheduleInfo?.unavailableDays;
      if (Array.isArray(blockedDates) && blockedDates) {
        blockedDates.splice(index, 1);
      }
      const updatedData = {
        unavailable: [...blockedDates],
        days: [...calendar?.calendarScheduleInfo?.scheduleDays],
      };
      try {
        const updateResponse = await axiosHttp.post("schedule", updatedData);
        if (
          updateResponse &&
          updateResponse?.status === 201 &&
          successCallback
        ) {
          successCallback("Blocked date deleted successfully");
        }
      } catch (err) {
        if (failureCallback) {
          failureCallback(err);
        }
      }
    }
  };
};
